import styled from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global';

export const GiftCardInfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${media.greaterThan('lg')} {
    max-width: 522px;
    width: 100%;
  }
`;
export const GiftCardTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};
  margin: ${spacing.L} 0;
  width: 100%;

  > * {
    margin-top: 0;
  }

  span {
    ${TypographyStyles.Headings.H5}
    display: block;
  }
`;
export const GiftCardTypeSelectorContainer = styled.div`
  display: flex;
  gap: 10px;
  height: 48px;
  justify-content: center;

  @media ${media.greaterThan('lg')} {
    min-height: 36px;
  }
`;
export const GiftCardTypeSelectorButton = styled.button<{ $isActive: boolean }>`
  ${({ $isActive }) => ($isActive ? TypographyStyles.Body.Small.SemiBold : TypographyStyles.Body.Small.Regular)}
  align-items: center;
  aspect-ratio: 1 / 3;
  background: ${({ $isActive }) => ($isActive ? colours.LIGHT_BLUE : 'none')};
  border: ${({ $isActive }) => ($isActive ? `1px solid ${colours.NAVY_BLUE}` : `1px solid ${colours.GREY}`)};
  color: ${colours.BLACK};
  cursor: ${({ $isActive }) => ($isActive ? 'unset' : 'pointer')};
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: auto;
  justify-content: center;
  min-height: 48px;
  padding: ${spacing.XXS} 10px;
  text-decoration: none;
  width: 49%;

  @media ${media.greaterThan('lg')} {
    padding: ${spacing.XXXXS} 10px;
  }
`;
